"use client";

import React from "react";
import Link from "next/link";

const FinalCta: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Ready to Restore Your Smile with Full Mouth Dental Implants Astoria
          Offers?
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Smile4Me Dental Care is not a one-size-fits-all practice.{" "}
          <Link
            href="/meet-your-dentist/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Dr. Khaimov
          </Link>{" "}
          evaluates your specific situation, explains your options honestly,
          and builds a treatment plan that fits your goals and your budget.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          What sets Smile4Me Dental Care apart is complete care under one roof.
          Extractions, 3D imaging, implant placement, and final restorations
          are all handled by the same trusted team. That means consistent care,
          fewer handoffs, and a smoother path to your new smile. Flexible
          financing ensures cost doesn&apos;t stand between you and a permanent
          solution.
        </p>
        <ul className="list-disc list-inside space-y-3 text-gray-700 text-base sm:text-lg leading-relaxed">
          <li>
            <strong>Call our Astoria office</strong> to speak with a team
            member and schedule your consultation
          </li>
          <li>
            <strong>Book online</strong> through our website; it takes less
            than two minutes
          </li>
          <li>
            <strong>Walk-in same-day</strong> appointments are often available
            for new patients
          </li>
        </ul>

        <p className="text-gray-800 text-base sm:text-lg leading-relaxed font-semibold pt-2">
          <Link
            href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            Schedule your free consultation
          </Link>{" "}
          at Smile4Me Dental Care in Astoria today. Your new smile is closer
          than you think.
        </p>

        <div className="pt-4 flex flex-col sm:flex-row gap-4 justify-center md:justify-start">
          <Link
            href="https://app.nexhealth.com/appt/smile4me_dental_care?lid=77847&tracking_key=b2d71902-5ce0-43c1-bc95-24cdee27de9a"
            target="_blank"
            rel="noopener noreferrer"
            className="
              uppercase font-semibold text-base tracking-wider text-white
              px-8 py-3
              bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F]
              hover:from-[#ECD05B] hover:via-[#AE7D2F] hover:to-[#ECD05B]
              rounded-lg shadow-lg hover:shadow-inner
              [text-shadow:1px_1px_2px_rgba(0,0,0,0.5)]
              hover:scale-105 transition-all duration-300 ease-in-out
              min-h-[44px] inline-flex items-center justify-center
            "
            aria-label="Schedule your free consultation online"
          >
            Schedule Your Free Consultation
          </Link>
          <a
            href="tel:+17184004400"
            className="
              uppercase font-semibold text-base tracking-wider text-[#AE7D2F]
              px-8 py-3
              bg-white border-2 border-[#AE7D2F]
              hover:bg-[#AE7D2F] hover:text-white
              rounded-lg shadow-lg
              hover:scale-105 transition-all duration-300 ease-in-out
              min-h-[44px] inline-flex items-center justify-center
            "
            aria-label="Call Smile4Me at (718) 400-4400"
          >
            Call (718) 400-4400
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCta;
